import { CLIENT_EVENT, EventLogger } from "@app/config/loggers/eventLogger";
import { useProjectAnalyticsGroup } from "@base/model/hooks";
import { AppLink } from "@base/ui/AppLink";
import { useSafeAreaInset } from "@base/ui/SafeArea/useSafeAreaInset";
import { sanitizeDocumentsSearch } from "@features/project-detail/model/dailyLogSearchNavigation";
import { ProjectPageHeader } from "@features/project-detail/ui/ProjectPageHeader";
import { ProjectTabNav } from "@features/project-detail/ui/ProjectTabNav";
import DailyWorkList from "@features/project-detail/ui/WorkHistory/DailyWorkList";
import { createFileRoute, useRouterState } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";
import { useEffect } from "react";

export const Route = createFileRoute("/_authenticated/projects/$projectId/history")({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId } = Route.useParams();
  const { bottom } = useSafeAreaInset();
  // 프로젝트 탭에서 넘어왔으면 그때의 Documents 검색 조건으로 돌아간다. 직접 들어왔으면 기본 목록.
  const documentsSearch = sanitizeDocumentsSearch(
    useRouterState({ select: (state) => state.location.state.projectDocumentsSearch }),
  );

  useProjectAnalyticsGroup(projectId);

  useEffect(
    function trackWorkHistoryView() {
      EventLogger.view(CLIENT_EVENT.WORK_HISTORY_VIEW, { project_id: projectId });
    },
    [projectId],
  );

  return (
    <div
      className="flex relative flex-col gap-4 p-4 h-dvh pb-[var(--safe-bottom-space)] md:px-0 md:pb-6"
      style={{ "--safe-bottom-space": `${16 + bottom}px` } as React.CSSProperties}
    >
      <ProjectPageHeader
        projectId={projectId}
        mobileTitle="Work History"
        mobileBackLink={
          <AppLink
            to="/projects/$projectId"
            params={{ projectId }}
            search={documentsSearch}
            aria-label="Back to project"
          >
            <ChevronLeft />
          </AppLink>
        }
      />
      <div className="hidden md:block md:-mt-4">
        <ProjectTabNav projectId={projectId} activeTab="history" documentsSearch={documentsSearch} />
      </div>

      <DailyWorkList projectId={projectId} />
    </div>
  );
}
